export enum LOGO_VARIANT {
  Color = 'color',
  Black = 'black',
  White = 'white',
  Circle = 'circle',
  Small = 'small',
}

export const LOGO_SRC = {
  [LOGO_VARIANT.Color]: 'logo_color.svg',
  [LOGO_VARIANT.Black]: 'logo_black.svg',
  [LOGO_VARIANT.White]: 'logo_white.svg',
  [LOGO_VARIANT.Circle]: 'logo_circle.svg',
  [LOGO_VARIANT.Small]: 'logo_small.png',
};
